function cov_1xwjipdntd() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/NewConstruction.tsx";
  var hash = "8af54ab20e63a3a7628732ea5de454ab8ab31a1c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/NewConstruction.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 56
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8af54ab20e63a3a7628732ea5de454ab8ab31a1c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1xwjipdntd = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1xwjipdntd();
var Icon = (cov_1xwjipdntd().s[0]++, {
  name: 'new-construction',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 3.29975L7.5 2.18864L5 3.29975V3.72222L9 5.5V7H10V3.29975ZM9 9V10V12H7H2H0V10V5.5L3 4.16667V2L7.5 0L12 2V7V9H10H9ZM4.5 5.68863L7 6.79975V10H2V6.79975L4.5 5.68863Z\" fill=\"currentColor\" />"
});
export default Icon;